import React from 'react';
import { withTheme } from 'styled-components';

import { withConfig } from 'Context/ConfigContext';

import WebAppLayout from './WebAppLayout';
import WebAppLayoutFullHeight from './WebAppLayoutFullHeight';
import BlankLayout from './BlankLayout';
import BlankPaasLayout from './BlankPaasLayout';
import DashboardLayout from './DashboardLayout';

// FIXME: [SKOOLDIO-4813] Separate between Web App layout or Mobile App layout
const ClassroomLayout = withConfig(
  withTheme(({ appConfig, theme, ...props }) => {
    const LayoutComponent =
      appConfig.classroom.layoutType === 'FIXED' ? WebAppLayoutFullHeight : WebAppLayout;
    return (
      <LayoutComponent
        footer={false}
        menu={false}
        contentContainerProps={{
          style: { height: '100%' },
          bg: theme.colors.contentBackground,
          mb: 0,
        }}
        {...props}
      />
    );
  })
);

const MobileAppLayout = (props) => <WebAppLayout footer={false} {...props} />;

const getAppLayout = (isNative, layoutProps) => {
  const Component = isNative ? MobileAppLayout : WebAppLayout;
  return (props) => <Component {...props} {...layoutProps} />;
};

export { ClassroomLayout, BlankLayout, BlankPaasLayout, DashboardLayout };

export default getAppLayout;
